import { render, staticRenderFns } from "./EscrowPending.vue?vue&type=template&id=0bf7d04c&scoped=true&"
import script from "./EscrowPending.vue?vue&type=script&lang=js&"
export * from "./EscrowPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf7d04c",
  null
  
)

export default component.exports